import { Component, OnInit, Renderer2, PLATFORM_ID, Inject, ChangeDetectorRef, Output, EventEmitter, ViewChild, TemplateRef, signal, DestroyRef, inject, NgZone, ElementRef } from '@angular/core';
import { ChatService } from '../../services/chat.service';
import { distinctUntilChanged, filter } from 'rxjs/operators';
import { ChatUser } from '../../models/chat/ChatUser';
import { Message } from '../../models/chat/Message';
import { environment } from '../../../environments/environment';
import { EncryptionService } from '../../services/encyption.service';
import { NavigationExtras, Router } from '@angular/router';
import { AuthGuardService } from '../../services/auth-guard.service';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { TerminkalenderService } from '../../services/terminkalender.service';
import { Mitarbeiter } from '../../models/mitarbeiter/Mitarbeiter';
import { Observable, Subscription, timer } from 'rxjs';
import { Office } from '../../models/mitarbeiter/Office';
import { Partner } from '../../models/partner/IPartner';
import { takeUntil } from 'rxjs/operators';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { ReCaptchaV3Service } from 'ng-recaptcha';
import { MatDialog } from '@angular/material/dialog';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ConfigService } from '../../services/config.service';
import { ElevenLabsVoiceService } from '../../services/elevenlabs-voice.service';
import { ElevenLabsRealtimeSttService } from '../../services/elevenlabs-realtime-stt.service';
import { ElevenLabsAgentService } from '../../services/elevenlabs-agent.service';

type AiProgressEvent = {
    jobId?: string;
    stage?: string;
    message?: string;
    step?: number;
    total?: number;
    status?: 'running' | 'complete' | 'error';
};

@Component({
    selector: 'app-chat',
    templateUrl: './chat.component.html',
    styleUrls: ['./chat.component.scss'],
    standalone: false
})
export class ChatComponent implements OnInit {
    @Output() triggerclosechat: EventEmitter<boolean> = new EventEmitter();
    @ViewChild('imgmdl', { static: true }) imgmdl: TemplateRef<any>;
    regg = /<(div|p|br)[^<]*?>/g;
    regg1 = /<\/(div|p)*?>/g;
    regg2 = /<br>/g;
    messages = signal<Message[]>([]);
    chatpanel: boolean = true;
    typing = signal<boolean>(false);
    desktopTemplate: string = 'xl';
    IchatUser: ChatUser;
    currentFrom: ChatUser;
    timeout;
    focus: boolean = false;
    imgPermission: boolean = false;
    cleartipingtimeout;
    scrollHeight: number;
    partnerid: string = '';
    mitarbeiters: Mitarbeiter[];
    mitarbObservable: Observable<Mitarbeiter[]>;
    currentMitarbeiter: Mitarbeiter;
    currentOffice: Office;
    offices: Office[];
    partner: Partner;
    chatLogoUrl: string = 'assets/tvg/logomobile.svg';
    reloadconfirmation = signal<boolean>(false);
    isBrowser: boolean = false;
    showwaiting30secLoading: boolean = false;
    timer30: number = 15;
    showwaiting30secLoadingSub: Subscription;
    aiWaiting = signal<boolean>(false);
    aiProgressMessage = signal<string>('Ich prüfe deine Anfrage...');
    aiProgressSteps = signal<string[]>([]);
    aiProgressJobId = signal<string>('');
    aiWaitingTimeout;
    aiResponseSyncTimeout;
    aiResponseSyncAttempt = 0;
    showphonformular: boolean = false;
    showphonsktvformular: boolean = false;
    showbookingformular: boolean = false;
    showmailformular: boolean = false;
    showTvInputChat: boolean = false;
    firstWaiting: boolean = true;
    secondWaiting: boolean = false;
    lastWaiting: boolean = false;
    activechatbtn: boolean = false;
    sktvnumber: string = '';
    bookingnumber: string = '';
    speechRecognition: any;
    speechSupported: boolean = false;
    speechListening = signal<boolean>(false);
    speechStatus = signal<string>('');
    private speechRestartTimer: any;
    private speechSessionText = '';
    voiceCallActive = signal<boolean>(false);
    voiceSpeaking = signal<boolean>(false);
    private voiceTurnSubmitting = false;
    private voiceAutoSendTimer: any;
    private voiceAudio?: HTMLAudioElement;
    private pendingAssistantSpeech = '';
    private currentAssistantSpeech = '';
    private usingElevenLabsAgent = false;
    isFlugb = signal<boolean>(false);

    showbigImage = signal<boolean>(false);
    loadingchatmodels = signal<boolean>(false);
    sendImgBtn = signal<boolean>(false);
    selectedblb: any;

    trackForm: FormGroup;

    destroyRef = inject(DestroyRef);

    gobackinmenu(): void { };
    showmb1: boolean = false;
    showmb2: boolean = false;
    showmb3: boolean = false;
    showmb3whaite: boolean = false;
    showmb4: boolean = false;
    showmb4whaite: boolean = false;
    showmb5: boolean = false;
    showmb5whaite: boolean = false;
    showmb6: boolean = false;
    showmb7: boolean = false;
    showandereFrageformular: boolean = false;
    showandereFrageformular1: boolean = false;
    showandereFrageformular2: boolean = false;
    sktvnumbererror: boolean = false;
    bookingnumberrerror: boolean = false;

    @ViewChild('filesBrowser') filesBrowser: any;
    @ViewChild('myEditable') myEditable: ElementRef<HTMLElement>;

    currentimage: string;

    rkp1: string = '?longitude=0.1&latitude=42.59151&startzoom=1&showtravelwarning=false&showcorona=false&showcompass=false&showinternational=false&showcoronatravel=true&poigroupid=&datamapid=&country=%7B"name":"Spanien","code":"ES"%7D';
    rkp2: string = '?longitude=0.1&latitude=42.59151&startzoom=1&showtravelwarning=false&showcorona=true&showcompass=false&showinternational=false&showcoronatravel=false&poigroupid=&datamapid=&country=%7B"name":"Spanien","code":"ES"%7D';
    msg1: string = 'Hallo, hier ist ';
    msg11: string = '. Ich sehe, dass Du gerade nach Reiseangeboten oder Reiseinformationen suchst. Wie kann ich Dir behilflich sein?';
    msg12: string = '. Du hast eine Frage zu einer bestehenden Reisebuchung. Ich bin gleich für Dich da. Du kannst mir schon mal Deine Buchungsnummer nennen.';
    msg3: string = 'Hallo, ich bin\'s. Bin leider noch verhindert. Du kannst gerne auf mich warten oder aus nachfolgenden Möglichkeiten wählen.';

    msg4: string = 'Hallo, hier ist der digitale Reise-Assistent von '
    msg41: string = '. Du hast eine Frage zu einer bestehenden Reisebuchung. Vielleicht kann ich dir schon weiterhelfen?';
    msg42: string = '. Du interessierst Dich für eine neue Reise. Gebe mir doch bitte schon mal einige Informationen - ggfs. kann ich Dir schon weiterhelfen?';

    msg5: string = 'Hallo, ';
    msg51: string = ' ist leider immer noch verhindert. Ich leite Deine Frage gerne an sie weiter – sie wird sich schnellstmöglich bei Dir melden. Vielen Dank für Dein Verständnis.';

    msg6: string = 'Hallo, hier ist ';
    msg61: string = '. Du hast eine Frage zu einer Suntour-Reisen Bestellnummer. Ich bin gleich für Dich da. Du kannst mir schon mal die Bestellnummer nennen.';
    msg7: string = 'Hallo, hier ist der digitale Reise-Assistent von ';
    msg71: string = '. Du hast eine Frage zu einer Suntour-Reisen Bestellnummer. Vielleicht kann ich dir schon weiterhelfen?';

    msg8: string = 'Hallo, hier ist ';
    msg81: string = '. Du interessierst Dich für eine neue Reise. Ich bin gleich für Dich da.';
    msfr1: string = 'Vielen Dank, wir werden dich so schnell wie möglich telefonisch kontaktieren!';
    msfr2: string = 'Vielen Dank, wir werden dich so schnell wie möglich kontaktieren!';

    constructor(
        protected chatService: ChatService,
        protected router: Router,
        protected guardService: AuthGuardService,
        protected mediaObserver: BreakpointObserver,
        protected dialog: MatDialog,
        protected encservice: EncryptionService,
        protected terminkalenderService: TerminkalenderService,
        protected cdr: ChangeDetectorRef,
        protected recaptchaV3Service: ReCaptchaV3Service,
        protected render: Renderer2,
        protected ngZone: NgZone,
        protected configService: ConfigService,
        private elevenLabsVoice: ElevenLabsVoiceService,
        private elevenLabsStt: ElevenLabsRealtimeSttService,
        private elevenLabsAgent: ElevenLabsAgentService,
        private fb: FormBuilder,
        @Inject(DOCUMENT) protected document: any,
        @Inject(PLATFORM_ID) protected platformId: any
    ) {
        this.isBrowser = isPlatformBrowser(this.platformId);
        this.isFlugb.set(Boolean(this.configService.getConfig().isFlugb));
    }

    ngOnInit(): void {
        if (this.isBrowser) {
            this.trackForm = this.fb.group({
                text: new FormControl('', []),
            });
            this.trackForm.controls['text'].valueChanges
                .pipe(takeUntilDestroyed(this.destroyRef))
                .subscribe(() => this.cdr.detectChanges());
            this.initSpeechRecognition();
            if (!this.detectRobot(navigator.userAgent) && !this.detectChromTest()) {
                this.initMedia();
                this.initPartner();
                this.messages.set([]);
            }
        }
    }

    resetRobot(): void {
        this.stopTimer();
        this.closeAllbtns();
        this.cdr.detectChanges();
    }

    detectRobot(userAgent: string): boolean {
        const robots = new RegExp(([
            /bot/, /spider/, /crawl/, // GENERAL TERMS
            /APIs-Google/, /AdsBot/, /Googlebot/, // GOOGLE ROBOTS
            /mediapartners/, /Google Favicon/, /GOOGLE/,
            /FeedFetcher/, /Google-Read-Aloud/,
            /DuplexWeb-Google/, /googleweblight/,
            /bing/, /yandex/, /baidu/, /duckduck/, /yahoo/, // OTHER ENGINES
            /ecosia/, /ia_archiver/, /cortex/,
            /facebook/, /instagram/, /pinterest/, /reddit/, // SOCIAL MEDIA
            /slack/, /twitter/, /whatsapp/, /Whatsapp/, /youtube/,
            /semrush/, // OTHER
        ] as RegExp[]).map((r) => r.source).join('|'), 'i'); // BUILD REGEXP + "i" FLAG

        return robots.test(userAgent);
    }

    detectChromTest(): boolean {
        if (navigator.userAgent.match(/(Mozilla\/5\.0 \(Linux; Android 11; moto g power \(2022\)\) AppleWebKit\/537\.36 \(KHTML, like Gecko\) Chrome\/109\.0.0.0 Mobile Safari\/537\.36)|(Mozilla\/5\.0 \(Macintosh; Intel Mac OS X 10_15_7\) AppleWebKit\/537\.36 \(KHTML, like Gecko\) Chrome\/109\.0\.0\.0 Safari\/537\.36)|(Speed Insights)|(Chrome-Lighthouse)/)) {
            return true;
        } else {
            return false;
        }
    }

    async initPartner() {
        this.guardService.getPartner$.pipe(
            takeUntilDestroyed(this.destroyRef)
        ).subscribe((partner: Partner) => {
            if (partner?.partnerid?.length > 0) {
                this.partner = partner;
                this.partnerid = partner?.partnerid;
                this.chatLogoUrl = partner?.logo
                    ? `https://suntour-reisen.de/logo/${partner.partnerid}/${partner.logo}`
                    : 'assets/tvg/logomobile.svg';
                this.initChatDaten();
            }
        });
    }

    chatBrandDomain(): string {
        const rawDomain = String(this.partner?.partnerdomain || '').trim();
        if (!rawDomain) {
            return 'suntour-reisen.de';
        }

        return rawDomain
            .replace(/^https?:\/\//i, '')
            .replace(/\/$/, '');
    }

    chatBrandUrl(): string {
        return `https://${this.chatBrandDomain()}`;
    }

    onChatLogoError(event: Event): void {
        const image = event.target as HTMLImageElement;
        image.src = 'assets/tvg/logomobile.svg';
    }

    async initMedia() {
        if (this.mediaObserver.isMatched(Breakpoints.XSmall)) {
            this.desktopTemplate = 'xs';
        }
        if (this.mediaObserver.isMatched(Breakpoints.Small)) {
            this.desktopTemplate = 'sm';
        }
        if (this.mediaObserver.isMatched(Breakpoints.Medium)) {
            this.desktopTemplate = 'md';
        }
        if (this.mediaObserver.isMatched(Breakpoints.Large)) {
            this.desktopTemplate = 'lg';
        }
        if (this.mediaObserver.isMatched(Breakpoints.XLarge)) {
            this.desktopTemplate = 'xl';
        }
        this.cdr.detectChanges();
    }

    async initChatDaten() {
        if (this.partnerid?.length > 0) {
            this.terminkalenderService.request({ partnerid: this.partnerid }, 'getchatmitarbeiters').pipe(
                takeUntilDestroyed(this.destroyRef)
            ).subscribe(res => {
                if (!res?.error) {
                    this.mitarbeiters = res;
                    const tmp = [];
                    for (let k = 0; k < res?.length; k++) {
                        if (res[k].userid > 0) {
                            tmp.push(res[k]);
                        }
                    }
                    if (this.mitarbeiters?.length > 0) {
                        const r = Math.floor(Math.random() * tmp?.length);
                        this.currentMitarbeiter = tmp[r];
                        this.activechatbtn = true;
                        this.cdr.detectChanges();
                        this.initChat();
                    }
                }
            });
        }
    }

    async initFromUser(mit) {
        for (let i = 0; i < this.mitarbeiters?.length; i++) {
            if (this.mitarbeiters[i].email === mit) {
                this.currentMitarbeiter = this.mitarbeiters[i];
                this.currentFrom = {
                    avatar: this.currentMitarbeiter.avatar,
                    username: this.currentMitarbeiter.email,
                    firstname: this.currentMitarbeiter.firstname,
                    lastname: this.currentMitarbeiter.lastname,
                    tel: this.currentMitarbeiter.tel,
                } as ChatUser;
                i = this.mitarbeiters?.length;
            }
        }
        this.cdr.detectChanges();
    }

    getAvatar(mit): boolean {
        if (mit?.username?.length > 0) {
            for (let i = 0; i < this.mitarbeiters?.length; i++) {
                if (this.mitarbeiters[i].email === mit.username) {
                    if (this.mitarbeiters[i].avatar?.length > 0) {
                        mit.avatar = this.mitarbeiters[i].avatar;
                        return true;
                    } else {
                        return false;
                    }
                }
            }
        }

        return false;
    }

    async openBigImage(img) {
        this.currentimage = img;
        const target = {
            width: '100%',
            height: '100%',
            maxWidth: '100%',
            autoFocus: false,
            panelClass: 'customModalimg'
        }
        const resf = this.dialog.open(this.imgmdl, target);
        resf.afterClosed().pipe(
            takeUntilDestroyed(this.destroyRef)
        ).subscribe(() => {
            this.currentimage = null;
            this.cdr.detectChanges();
        });
    }

    async downloadImg() {
        const link = document.createElement('a');
        link.download = '';
        link.href = this.currentimage;
        link.click();
    }

    async newChat() {
        this.reloadconfirmation.set(true); // show confirmation
        this.cdr.detectChanges();
    }

    async resetChat() {
        this.resetRobot();
        this.messages.set([]);
        this.reloadconfirmation.set(false);
        const oldName = window.localStorage.getItem(this.partnerid + '_sessionid') || '';
        const newName = this.createChatSessionId();
        window.localStorage.setItem(this.partnerid + '_sessionid', newName);
        this.IchatUser = {
            last_connection: new Date(),
            status: 1,
            type: 'web',
            username: newName,
            stopRobot: false,
        } as ChatUser;
        await this.chatService.resetUsername(oldName, newName);
        this.cdr.detectChanges();
    }

    private createChatSessionId(): string {
        const cryptoApi = window.crypto as Crypto | undefined;
        if (cryptoApi?.randomUUID) {
            return cryptoApi.randomUUID().replace(/-/g, '').slice(0, 16);
        }

        const random = new Uint8Array(8);
        if (cryptoApi?.getRandomValues) {
            cryptoApi.getRandomValues(random);
            return Array.from(random).map((value) => value.toString(16).padStart(2, '0')).join('');
        }

        return `${Date.now().toString(36)}${Math.random().toString(36).slice(2, 10)}`.slice(0, 16);
    }

    async initsocket() {
        this.chatService.connectToServer();

        this.initUserNameOb();
        this.checkNewMessageOb();
        this.checkAiProgressOb();
        this.checkTypingOb();
        this.checkImgPermission();
        this.checkStopRobot();
    }

    async checkStopRobot() {
        this.chatService.onsendStopRobot()
            .pipe(
                takeUntilDestroyed(this.destroyRef),
                distinctUntilChanged()
            ).subscribe((data: any) => {
                this.IchatUser.stopRobot = data.stopRobot;
                this.cdr.detectChanges();
                if (data.stopRobot) {
                    this.endVoiceCall();
                    this.resetRobot();
                }
            });
    }

    async checkTypingOb() {
        this.chatService.onTyping()
            .pipe(
                takeUntilDestroyed(this.destroyRef),
                distinctUntilChanged()
            ).subscribe((typing: boolean) => {
                this.typing.set(typing);
                this.cdr.detectChanges();
                clearTimeout(this.cleartipingtimeout);
                this.cleartipingtimeout = setTimeout(() => {
                    this.typing.set(false);
                    this.cdr.detectChanges();
                }, 30000);
            });
    }

    async checkImgPermission() {
        this.chatService.imgPermission()
            .pipe(
                takeUntilDestroyed(this.destroyRef),
                distinctUntilChanged()
            ).subscribe((prm: boolean) => {
                this.imgPermission = prm;
            });
    }

    async checkNewMessageOb() {
        this.chatService.onNewMessage()
            .pipe(
                takeUntilDestroyed(this.destroyRef),
                distinctUntilChanged(),
                filter((msg: Message) => (msg.message?.trim().length > 0 && msg.type !== 'zoom' && msg.type !== 'link') || (msg.type === 'zoom' || msg.type === 'link'))
            ).subscribe(msg => this.ngZone.run(() => {
                const currentSessionId = window.localStorage.getItem(
                    this.partnerid + '_sessionid',
                );
                if (
                    !currentSessionId ||
                    (
                        msg.from?.username !== currentSessionId &&
                        msg.to?.username !== currentSessionId
                    )
                ) {
                    return;
                }
                this.stopAiResponseSync();
                this.stopAiWaiting();
                this.resetRobot();
                const mm = msg?.message?.replace(/ /g, '+');
                const tokenFromUI = mm?.slice(-16);
                const data = mm?.slice(0, (mm?.length - 16));
                const msgd = this.encservice.deencrypt(tokenFromUI, data);
                const realmsg = JSON.parse(msgd);
                msg.message = this.normalizeAiMessageHtml(realmsg);
                this.appendMessage(msg);
                if (msg.type === 'robot') this.speakAssistantReply(String(realmsg || ''));
            }));
    }

    async checkAiProgressOb() {
        this.chatService.onAiProgress<AiProgressEvent>()
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe(progress => this.ngZone.run(() => {
                if (!progress || progress.status === 'complete' || progress.status === 'error') {
                    this.stopAiWaiting();
                    return;
                }

                const message = String(progress.message || '').trim();
                if (!message) {
                    return;
                }

                const incomingJobId = String(progress.jobId || '');
                if (incomingJobId && incomingJobId !== this.aiProgressJobId()) {
                    this.aiProgressJobId.set(incomingJobId);
                    this.aiProgressSteps.set([]);
                }

                const previousMessage = this.aiProgressMessage();
                if (
                    previousMessage &&
                    previousMessage !== 'Ich prüfe deine Anfrage...' &&
                    previousMessage !== message
                ) {
                    this.aiProgressSteps.update(steps => (
                        [...steps.filter(step => step !== previousMessage), previousMessage].slice(-4)
                    ));
                }

                this.aiProgressMessage.set(message);
                this.aiWaiting.set(true);
                clearTimeout(this.aiWaitingTimeout);
                this.aiWaitingTimeout = setTimeout(() => this.stopAiWaiting(), 120000);
                this.cdr.detectChanges();
                setTimeout(() => this.scroolDown(), 50);
            }));
    }

    async initUserNameOb() {
        this.chatService.updateusername()
            .pipe(
                takeUntilDestroyed(this.destroyRef),
            ).subscribe((user: any) => {
                if (user) {
                    this.IchatUser = {
                        last_connection: new Date(),
                        status: 1,
                        type: 'web',
                        username: user.username,
                        stopRobot: user.stopRobot,
                    } as ChatUser;
                    if (user.username?.length > 0) {
                        this.getmymesages(user.username);
                    }
                }
                this.cdr.detectChanges();
            });
    }

    async getmymesages(username, options: { silent?: boolean } = {}) {
        const requestedUsername = String(username || '');
        this.chatService.getmymesages<string, Array<Message>>(username, (messages) => {
            this.ngZone.run(() => {
                const currentSessionId = window.localStorage.getItem(
                    this.partnerid + '_sessionid',
                );
                if (
                    !requestedUsername ||
                    requestedUsername !== currentSessionId ||
                    requestedUsername !== this.IchatUser?.username
                ) {
                    return;
                }
                for (let i = 0; i < messages.length; i++) {
                    const mm = messages[i].message.replace(/ /g, '+');
                    const tokenFromUI = mm?.slice(-16);
                    const data = mm?.slice(0, (mm.length - 16));
                    try {
                        const realmsg = JSON.parse(this.encservice.deencrypt(tokenFromUI, data));
                        messages[i].message = this.normalizeAiMessageHtml(realmsg);
                    } catch (error) {
                        // console.log(error);
                    }
                }
                // Old KI welcomes may still exist in MongoDB from a prior chat
                // session.  With ElevenLabs disabled, this is the normal human
                // chat, so never replay those automatic greetings to visitors.
                const visibleMessages = this.partner?.ai?.elevenLabsEnabled === true
                    ? messages
                    : messages.filter((message) => message.assistantGreeting !== true);
                this.messages.set(visibleMessages);
                this.cdr.detectChanges();
                if (options.silent) {
                    const lastMessage = visibleMessages[visibleMessages.length - 1];
                    const assistantArrived = Boolean(
                        lastMessage &&
                        lastMessage.from?.username !== requestedUsername &&
                        lastMessage.from?.type !== 'web',
                    );
                    if (assistantArrived) {
                        this.stopAiResponseSync();
                        this.stopAiWaiting();
                        this.resetRobot();
                    }
                    setTimeout(() => {
                        this.scroolDown();
                    }, 300);
                    return;
                }
                // suntourserver owns the first ElevenLabs greeting after the
                // explicit `startChatSession` socket event.  Do not start a
                // second browser-side ElevenLabs session here: it produces a
                // duplicate greeting for the same chat user.
                if (this.isElevenLabsTextChatEnabled()) {
                    this.resetRobot();
                    setTimeout(() => this.scroolDown(), 300);
                    return;
                }
                if (!this.IchatUser.stopRobot && visibleMessages.length === 0) {
                    this.startTalk();
                } else if (this.IchatUser.stopRobot || this.isAiChatActive()) {
                    this.resetRobot();
                    setTimeout(() => {
                        this.scroolDown();
                    }, 300);
                } else {
                    this.startTalk();
                }
            });
        });
    }

    applyQuickReply(text: string): void {
        const value = String(text || '');
        this.trackForm?.controls?.['text']?.setValue(value);
        this.setComposerDomText(value);
        this.focusComposerEnd();
        this.cdr.detectChanges();
    }

    private setComposerDomText(text: string): void {
        if (this.myEditable?.nativeElement) {
            this.myEditable.nativeElement.innerText = text || '';
        }
    }

    private focusComposerEnd(): void {
        if (!this.isBrowser || !this.myEditable?.nativeElement) {
            return;
        }

        const element = this.myEditable.nativeElement;
        window.setTimeout(() => {
            element.focus();
            const selection = window.getSelection();
            if (!selection) {
                return;
            }

            const range = document.createRange();
            range.selectNodeContents(element);
            range.collapse(false);
            selection.removeAllRanges();
            selection.addRange(range);
        });
    }

    private clearComposer(): void {
        this.trackForm?.controls?.['text']?.setValue('', { emitEvent: false });
        this.setComposerDomText('');
        this.cdr.detectChanges();
    }

    composerHasText(): boolean {
        const value = String(this.trackForm?.controls?.['text']?.value || '')
            .replace(this.regg, '')
            .replace(this.regg1, '')
            .trim();
        return value.length > 0;
    }

    async sendButtonClick() {
        const tmp = this.trackForm.value.text?.replace(this.regg, '')?.replace(this.regg1, '\n');
        // Sending is also the explicit end of a voice turn, including when
        // the browser has not produced a final transcript yet.
        this.stopSpeechRecognition();
        if (tmp.length > 0) {
            this.sendMessage(this.trackForm.value.text?.replace(this.regg, '')?.replace(this.regg1, '\n'));
            this.clearComposer();
        }
    }

    initSpeechRecognition(): void {
        if (!this.isBrowser) {
            return;
        }

        const SpeechRecognition = (window as any).SpeechRecognition || (window as any).webkitSpeechRecognition;
        this.speechSupported = !!SpeechRecognition;
        if (!this.speechSupported) {
            return;
        }

        this.speechRecognition = new SpeechRecognition();
        this.speechRecognition.lang = 'de-DE';
        this.speechRecognition.interimResults = true;
        this.speechRecognition.continuous = true;

        // Browser speech recognition runs outside Angular, so update the form inside the Angular zone.
        this.speechRecognition.onresult = (event) => {
            const transcript = Array.from(event.results)
                .map((result: any) => result?.[0]?.transcript || '')
                .join(' ')
                .trim();
            const value = [this.speechSessionText, transcript]
                .filter(Boolean)
                .join(this.speechSessionText && transcript ? ' ' : '')
                .trim();

            this.ngZone.run(() => {
                this.trackForm.controls['text'].setValue(value);
                this.setComposerDomText(value);
                this.speechStatus.set('');
                this.cdr.detectChanges();
            });

        };

        // Unlike a fixed timeout, `speechend` is emitted by the browser's
        // voice-activity detector when the customer has stopped speaking.
        this.speechRecognition.onspeechstart = () => {
            clearTimeout(this.voiceAutoSendTimer);
        };

        this.speechRecognition.onspeechend = () => {
            if (!this.voiceCallActive() || this.voiceTurnSubmitting) return;
            // Give the recognition engine one short event loop to commit its
            // final words before reading the composer and sending the turn.
            clearTimeout(this.voiceAutoSendTimer);
            this.voiceAutoSendTimer = window.setTimeout(() => this.acknowledgeAndSendVoiceTurn(), 250);
        };

        this.speechRecognition.onend = () => {
            this.ngZone.run(() => {
                if (!this.speechListening()) {
                    this.cdr.detectChanges();
                    return;
                }
                // Chrome may still close a continuous session after silence.
                // Keep the text and resume listening without losing it.
                this.speechSessionText = String(this.trackForm?.controls?.['text']?.value || '').trim();
                clearTimeout(this.speechRestartTimer);
                this.speechRestartTimer = window.setTimeout(() => {
                    if (!this.speechListening()) return;
                    try {
                        this.speechRecognition.start();
                    } catch (_) {
                        this.speechListening.set(false);
                    }
                    this.cdr.detectChanges();
                }, 180);
            });
        };

        this.speechRecognition.onerror = (event: any) => {
            this.ngZone.run(() => {
                // `no-speech` is normal while the customer is thinking; the
                // following onend opens the next continuous session.
                if (event?.error === 'no-speech' && this.speechListening()) {
                    return;
                }
                if (!this.speechListening()) {
                    return;
                }
                this.speechListening.set(false);
                this.speechStatus.set(this.speechErrorMessage(event?.error));
                this.cdr.detectChanges();
            });
        };
    }

    async toggleSpeechRecognition(): Promise<void> {
        if (!this.speechSupported || !this.speechRecognition) {
            return;
        }

        if (this.voiceCallActive() && this.voiceSpeaking()) {
            this.interruptAssistantSpeech();
        }

        if (this.speechListening()) {
            this.stopSpeechRecognition();
            return;
        }

        // Request audio access explicitly. SpeechRecognition otherwise leaves
        // some browsers in an active-looking state without ever producing a
        // transcript or a useful permission error.
        try {
            const stream = await navigator.mediaDevices?.getUserMedia?.({ audio: true });
            stream?.getTracks().forEach((track) => track.stop());
        } catch (error: any) {
            this.speechListening.set(false);
            this.speechStatus.set(this.speechErrorMessage(error?.name || 'not-allowed'));
            this.cdr.detectChanges();
            return;
        }

        try {
            this.speechSessionText = String(this.trackForm?.controls?.['text']?.value || '').trim();
            this.speechListening.set(true);
            this.speechStatus.set('');
            this.speechRecognition.start();
        } catch (error: any) {
            this.speechListening.set(false);
            this.speechStatus.set(this.speechErrorMessage(error?.name));
            this.cdr.detectChanges();
        }
    }

    private speechErrorMessage(error: string): string {
        if (/not-allowed|service-not-allowed|security/i.test(String(error || ''))) {
            return 'Bitte erlaube den Mikrofonzugriff im Browser.';
        }
        if (/network/i.test(String(error || ''))) {
            return 'Die Spracherkennung ist gerade nicht erreichbar. Bitte erneut versuchen.';
        }
        return 'Die Spracherkennung konnte nicht gestartet werden. Bitte erneut versuchen.';
    }

    stopSpeechRecognition(): void {
        if (!this.speechRecognition || !this.speechListening()) {
            return;
        }

        clearTimeout(this.speechRestartTimer);
        this.speechListening.set(false);
        // Chrome may synchronously emit `onend`; mark the turn stopped first
        // so that handler cannot reopen the microphone.
        this.speechRecognition.stop();
        this.speechStatus.set('');
    }

    async toggleVoiceCall(): Promise<void> {
        if (this.voiceCallActive()) {
            this.endVoiceCall();
            return;
        }
        this.voiceCallActive.set(true);
        this.speechStatus.set('Verbinde mit dem Reiseassistenten …');
        try {
            this.usingElevenLabsAgent = true;
            await this.elevenLabsAgent.start(
                this.partnerid,
                mode => this.ngZone.run(() => this.speechStatus.set(mode === 'speaking' ? 'Der Reiseassistent antwortet …' : 'Anruf aktiv – ich höre zu.')),
                () => this.ngZone.run(() => this.speechStatus.set('Der ElevenLabs-Agent ist gerade nicht erreichbar.')),
                (message, source, conversationId) => this.addElevenLabsAgentMessage(message, source, conversationId),
                (toolName, toolResult) => this.addElevenLabsOfferCards(toolName, toolResult),
            );
        } catch (error: any) {
            this.usingElevenLabsAgent = false;
            this.voiceCallActive.set(false);
            const status = Number(error?.status || 0);
            this.speechStatus.set(
                status
                    ? `Der ElevenLabs-Agent konnte nicht gestartet werden (HTTP ${status}).`
                    : 'Der ElevenLabs-Agent konnte nicht gestartet werden. Details stehen in der Browser-Konsole.',
            );
        }
    }

    endVoiceCall(): void {
        clearTimeout(this.voiceAutoSendTimer);
        this.voiceCallActive.set(false);
        this.voiceSpeaking.set(false);
        this.voiceTurnSubmitting = false;
        this.pendingAssistantSpeech = '';
        this.stopSpeechRecognition();
        this.voiceAudio?.pause();
        this.voiceAudio = undefined;
        this.elevenLabsStt.stop();
        if (this.usingElevenLabsAgent) this.elevenLabsAgent.stop();
        this.usingElevenLabsAgent = false;
        this.speechStatus.set('');
    }

    private onRealtimeVoicePartial(text: string): void {
        this.ngZone.run(() => {
            const value = String(text || '').trim();
            if (!value) return;
            if (this.voiceSpeaking() && this.isAssistantEcho(value)) return;
            if (this.voiceSpeaking()) this.interruptAssistantSpeech();
            this.trackForm.controls['text'].setValue(value);
            this.setComposerDomText(value);
            this.cdr.detectChanges();
        });
    }

    private addElevenLabsAgentMessage(text: string, source: 'user' | 'ai', conversationId: string): void {
        const content = this.localizeElevenLabsBranding(this.stripElevenLabsSpeechCues(text));
        if (!content) return;
        const isUser = source === 'user';
        this.appendMessage({
            message: this.normalizeAiMessageHtml(content),
            type: 'elevenlabs-agent',
            from: isUser
                ? (this.IchatUser || { username: window.localStorage.getItem(this.partnerid + '_sessionid'), type: 'web', status: 1, last_connection: new Date() })
                : { username: 'elevenlabs-agent', type: 'backoffice', status: 1, last_connection: new Date(), firstname: 'Reisebüro', lastname: 'Assistent' },
            to: isUser
                ? { username: 'elevenlabs-agent', type: 'backoffice', status: 1, last_connection: new Date() }
                : (this.IchatUser || { username: window.localStorage.getItem(this.partnerid + '_sessionid'), type: 'web', status: 1, last_connection: new Date() }),
            status: 1,
            date: new Date(),
        } as Message);
        const username = String(this.IchatUser?.username || window.localStorage.getItem(this.partnerid + '_sessionid') || '');
        if (this.partnerid && username) {
            this.elevenLabsVoice.saveAgentTranscript({
                partnerid: this.partnerid,
                username,
                text: content,
                source,
                conversationId,
            }).catch(() => console.warn('[ElevenLabs agent] Transcript could not be saved.'));
        }
    }

    private addElevenLabsOfferCards(toolName: string, toolResult: unknown): void {
        this.elevenLabsVoice.renderAgentOfferCards(this.partnerid, toolName, toolResult)
            .then((result) => {
                const cardsHtml = String(result?.cardsHtml || '');
                if (!cardsHtml.includes('data-ai-card')) return;
                const username = String(this.IchatUser?.username || window.localStorage.getItem(this.partnerid + '_sessionid') || '');
                this.appendMessage({
                    message: this.normalizeAiMessageHtml(cardsHtml),
                    type: 'elevenlabs-agent',
                    from: { username: 'elevenlabs-agent', type: 'backoffice', status: 1, last_connection: new Date(), firstname: 'Reisebüro', lastname: 'Assistent' },
                    to: this.IchatUser || { username, type: 'web', status: 1, last_connection: new Date() },
                    status: 1,
                    date: new Date(),
                } as Message);
            })
            .catch(() => console.warn('[ElevenLabs agent] Offer cards could not be rendered.'));
    }

    // ElevenLabs may send voice-direction tags such as [happy] or [apologetic].
    // They are useful to its speech model but are not customer-facing chat text.
    private stripElevenLabsSpeechCues(text: string): string {
        const cues = [
            'happy', 'sad', 'excited', 'cheerful', 'friendly', 'concerned',
            'apologetic', 'empathetic', 'calm', 'serious', 'enthusiastic',
            'laugh', 'laughs', 'sigh', 'whisper',
        ].join('|');
        return String(text || '')
            .replace(new RegExp(`\\s*\\[(?:${cues})\\]\\s*`, 'gi'), ' ')
            .replace(/\s{2,}/g, ' ')
            .trim();
    }

    /**
     * The shared ElevenLabs agent may still return its legacy Suntour greeting.
     * Keep the agent configuration untouched and white-label only the text
     * rendered in this partner's chat.
     */
    private localizeElevenLabsBranding(text: string): string {
        const brand = String(this.partner?.firmenname || this.partner?.partnerdomain || '')
            .trim()
            .replace(/^https?:\/\//i, '')
            .replace(/\/$/, '');
        if (!brand) return text;

        return String(text || '')
            .replace(/Kim\s+von\s+sonnenklar\.TV/gi, `dein Reiseassistent von ${brand}`)
            .replace(/\bsonnenklar\.TV\b/gi, brand);
    }

    private onRealtimeVoiceCommitted(text: string): void {
        this.ngZone.run(() => {
            const value = String(text || '').trim();
            if (!value || this.voiceTurnSubmitting || this.isAssistantEcho(value)) return;
            if (this.voiceSpeaking()) this.interruptAssistantSpeech();
            this.trackForm.controls['text'].setValue(value);
            this.setComposerDomText(value);
            this.acknowledgeAndSendVoiceTurn();
        });
    }

    private isAssistantEcho(text: string): boolean {
        const normalize = (value: string) => value.toLowerCase().replace(/[^a-zäöüß0-9 ]/g, ' ').replace(/\s+/g, ' ').trim();
        const heard = normalize(text);
        const spoken = normalize(this.currentAssistantSpeech);
        return heard.length > 4 && spoken.includes(heard);
    }

    private interruptAssistantSpeech(): void {
        this.voiceAudio?.pause();
        this.voiceAudio = undefined;
        this.voiceSpeaking.set(false);
        this.voiceTurnSubmitting = false;
        this.pendingAssistantSpeech = '';
        this.currentAssistantSpeech = '';
        this.speechStatus.set('Antwort unterbrochen – ich höre zu.');
    }

    private acknowledgeAndSendVoiceTurn(): void {
        if (!this.voiceCallActive() || this.voiceSpeaking() || this.voiceTurnSubmitting) return;
        const text = String(this.trackForm?.controls?.['text']?.value || '').replace(this.regg, '').replace(this.regg1, '\n').trim();
        if (!text) return;
        clearTimeout(this.voiceAutoSendTimer);
        this.voiceTurnSubmitting = true;
        this.stopSpeechRecognition();
        this.speechSessionText = '';
        this.speechStatus.set('Ich prüfe deine Anfrage …');
        // Start the expensive KI search immediately. The short spoken
        // acknowledgement plays in parallel instead of delaying the search.
        this.sendVoiceTurn(text);
        this.playVoiceAcknowledgement();
    }

    private async playVoiceAcknowledgement(): Promise<void> {
        this.voiceSpeaking.set(true);
        this.currentAssistantSpeech = 'Einen Moment bitte, ich prüfe passende Angebote für dich.';
        try {
            const audioBlob = await this.elevenLabsVoice.synthesize('Einen Moment bitte, ich prüfe passende Angebote für dich.');
            if (!this.voiceCallActive()) return;
            const url = URL.createObjectURL(audioBlob);
            const audio = new Audio(url);
            this.voiceAudio = audio;
            audio.onended = () => {
                URL.revokeObjectURL(url);
                this.voiceSpeaking.set(false);
                this.finishVoiceAcknowledgement();
            };
            audio.onerror = () => {
                URL.revokeObjectURL(url);
                this.voiceSpeaking.set(false);
                this.finishVoiceAcknowledgement();
            };
            await audio.play();
        } catch (_) {
            this.voiceSpeaking.set(false);
            this.finishVoiceAcknowledgement();
        }
    }

    private finishVoiceAcknowledgement(): void {
        if (this.pendingAssistantSpeech) {
            const reply = this.pendingAssistantSpeech;
            this.pendingAssistantSpeech = '';
            this.speakAssistantReply(reply);
        }
    }

    private sendVoiceTurn(text: string): void {
        if (!this.voiceCallActive() || !this.voiceTurnSubmitting) return;
        this.speechStatus.set('Deine Nachricht wird gesendet …');
        this.sendMessage(text);
        this.clearComposer();
    }

    private async speakAssistantReply(message: string): Promise<void> {
        if (!this.voiceCallActive() || this.usingElevenLabsAgent) return;
        if (this.voiceSpeaking()) {
            this.pendingAssistantSpeech = message;
            return;
        }
        const text = String(message || '').replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim();
        if (!text) return this.resumeVoiceListening();
        this.voiceSpeaking.set(true);
        this.currentAssistantSpeech = text;
        this.speechStatus.set('Der Reiseassistent antwortet …');
        try {
            const audioBlob = await this.elevenLabsVoice.synthesize(text);
            if (!this.voiceCallActive()) return;
            const url = URL.createObjectURL(audioBlob);
            const audio = new Audio(url);
            this.voiceAudio = audio;
            audio.onended = () => {
                URL.revokeObjectURL(url);
                this.voiceSpeaking.set(false);
                this.resumeVoiceListening();
            };
            audio.onerror = () => {
                URL.revokeObjectURL(url);
                this.voiceSpeaking.set(false);
                this.speechStatus.set('Die Sprachantwort konnte nicht abgespielt werden.');
                this.resumeVoiceListening();
            };
            await audio.play();
        } catch (error: any) {
            this.voiceSpeaking.set(false);
            const status = Number(error?.status || 0);
            this.speechStatus.set(
                status === 503
                    ? 'Die ElevenLabs-Konfiguration wurde vom Server noch nicht geladen. Bitte Server neu starten.'
                    : status === 502
                        ? 'ElevenLabs hat die Sprachantwort abgelehnt. Bitte API-Key und Voice ID prüfen.'
                        : 'Die Sprachantwort konnte nicht geladen werden. Bitte erneut versuchen.',
            );
            this.resumeVoiceListening();
        }
    }

    private async resumeVoiceListening(): Promise<void> {
        if (!this.voiceCallActive()) return;
        this.voiceTurnSubmitting = false;
        this.speechStatus.set('Anruf aktiv – ich höre zu.');
    }

    async sendMessage(text, isOption?: boolean, type?: string) {
        // clearTimeout(this.cleartimeoutwaitingChat);
        if (!this.IchatUser) {
            this.IchatUser = {
                last_connection: new Date(),
                status: 1,
                type: 'web',
                username: window.localStorage.getItem(this.partnerid + '_sessionid')
            } as ChatUser;
        }
        const message = {
            message: this.encservice.encrypt(text),
            type: type || 'text',
            from: this.IchatUser,
            to: {
                last_connection: new Date(),
                status: 1,
                type: 'backoffice',
                username: 'backoffice'
            },
            status: 1,
            date: new Date()
        } as Message;
        // send message
        this.chatService.sendMessage<Message>(message, (res) => {
            // Add message in to the list
            message.message = text;
            this.appendMessage(message);
            setTimeout(() => {
                this.scroolDown();
            }, 500);
            if (res === 'ok') {
                message.status = 1;
            } else {
                message.status = -1;
            }
            if (this.shouldUseElevenLabsTextAgent(isOption, type)) {
                this.resetRobot();
                this.startAiWaiting();
                // The message has already been sent through Socket.IO above.
                // suntourserver is the only component allowed to contact
                // ElevenLabs and will return its reply through msgfrombck.
                console.info('[ElevenLabs text] Chat turn delegated to suntourserver', {
                    partnerid: this.partnerid,
                    length: String(text || '').length,
                });
            } else if (this.shouldUseAiAnswer(isOption, type)) {
                this.resetRobot();
                this.startAiWaiting();
                this.scheduleAiResponseSync();
            } else if (!this.IchatUser.stopRobot && !isOption) {
                this.resetRobot();
                this.gobackinmenu = this.returnmb1.bind(this);
                this.waiting30sec(() => {
                    this.resetRobot();
                    this.createHibridMessage(this.msg3, () => {
                        this.showmb2 = true;
                        this.cdr.detectChanges();
                        setTimeout(() => {
                            this.scroolDown();
                        }, 300);
                    });
                });
            }
            // this.createRobotMessage('einen kurzen Moment bitte. Ich bin gleich für sie da !');
        });
    }

    keypress(ev) {
        if (ev.which === 13 && !ev.shiftKey) {
            ev.preventDefault();
            ev.stopPropagation();
            const tmp = this.trackForm.value.text?.replace(this.regg, '')?.replace(this.regg1, '\n');
            if (tmp.length > 0) {
                this.sendMessage(tmp);
                this.clearComposer();
                clearTimeout(this.timeout);
                this.timeout = setTimeout(() => {
                    this.chatService.sendTyping(this.IchatUser, false);
                }, 3000);
            }
        } else {
            this.chatService.sendTyping(this.IchatUser, true);
            clearTimeout(this.timeout)
            this.timeout = setTimeout(() => {
                this.chatService.sendTyping(this.IchatUser, false);
            }, 30000);
        }
    }

    async gotozoom(params) {
        if (environment.production) {
            const domain = this.document.domain.startsWith('demo.') ? 'https://zoom' : 'https://zoom.';
            window.open(domain + this.document.domain + '?param=' + params, '_blank', 'noopener');
        } else {
            window.open('https://localhost:3336?param=' + params, '_blank', 'noopener');
        }
    }

    async gotoLink(link) {
        window.open(link, '_blank', 'noopener');
    }

    appendMessage(message: Message): void {
        this.ngZone.run(() => {
            this.messages.update((messages) => [...messages, message]);
            this.cdr.detectChanges();
            this.refreshChatAfterMessage(0);
            this.refreshChatAfterMessage(200);
            this.refreshChatAfterMessage(500);
            this.refreshChatAfterMessage(1000);
        });
    }

    refreshChatAfterMessage(delay: number): void {
        setTimeout(() => {
            this.cdr.detectChanges();
            this.scroolDown('auto');
        }, delay);
    }

    normalizeAiMessageHtml(html: any): any {
        const containsMarkdownLink = typeof html === 'string' && /\[[^\]\r\n]+\]\(https?:\/\//i.test(html);
        if (typeof html !== 'string' || (!html.includes('data-ai-') && !containsMarkdownLink) || !this.document?.createElement) {
            return html;
        }

        html = html.replace(/\[\[AI_LINK:[^\]]+]]/g, '');
        // ElevenLabs returns offer URLs as Markdown, e.g.
        // [Zum Angebot](https://...).  AI-card messages bypass the normal
        // linkify pipe, so turn that safe, explicit form into a real link
        // before the server HTML is rendered.
        html = html.replace(/\[([^\]\r\n]{1,160})\]\((https?:\/\/[^\s)<]+)\)/gi, (_match, label, href) => {
            const safeLabel = String(label)
                .replace(/&/g, '&amp;')
                .replace(/</g, '&lt;')
                .replace(/>/g, '&gt;');
            const safeHref = String(href).replace(/"/g, '%22');
            return `<a href="${safeHref}" data-ai-link="${safeHref}" data-ai-text-link="true" target="_blank" rel="noopener noreferrer">${safeLabel}</a>`;
        });
        const wrapper = this.document.createElement('div');
        wrapper.innerHTML = html;

        wrapper.querySelectorAll('img[src]').forEach((element: Element) => {
            const img = element as HTMLImageElement;
            const rawSrc = img.getAttribute('src') || '';
            const embeddedAlt = rawSrc.match(
                /["'“”‘’]\s+alt\s*=\s*["'“”‘’]([^"'“”‘’<>]+)/i,
            )?.[1]?.trim();
            const cleanSrc = rawSrc
                .split(/["'“”‘’]\s+(?:alt|style|class|width|height)\s*=/i)[0]
                .trim();
            if (cleanSrc && cleanSrc !== rawSrc) {
                img.setAttribute('src', cleanSrc);
            }
            if (embeddedAlt && !img.getAttribute('alt')) {
                img.setAttribute('alt', embeddedAlt);
            }
        });

        const offerResponse = wrapper.querySelector(
            '[data-ai-offer-response="true"], [data-ai-hotel-response="true"]',
        ) as HTMLElement;
        if (offerResponse) {
            offerResponse.style.cssText = 'box-sizing:border-box;display:flex;flex-direction:column;gap:12px;max-width:100%;padding:14px;border-radius:0 18px 18px 18px;background:#f75a00;color:#fff;font-family:inherit;';
            const title = offerResponse.querySelector('div:first-child') as HTMLElement;
            if (title) {
                title.style.cssText = 'font-weight:800;font-size:18px;line-height:1.2;';
            }
        }

        const noOfferResponse = wrapper.querySelector(
            '[data-ai-no-offer-response="true"], [data-ai-no-hotel-response="true"]',
        ) as HTMLElement;
        if (noOfferResponse) {
            noOfferResponse.style.cssText = 'box-sizing:border-box;display:flex;flex-direction:column;gap:12px;max-width:100%;padding:16px;border-radius:0 18px 18px 18px;background:#f75a00;color:#fff;font-family:inherit;';
            const title = noOfferResponse.querySelector('div:first-child') as HTMLElement;
            const text = noOfferResponse.querySelector('div:nth-child(2)') as HTMLElement;
            if (title) {
                title.style.cssText = 'font-weight:800;font-size:18px;line-height:1.2;';
            }
            if (text) {
                text.style.cssText = 'font-weight:600;font-size:14px;line-height:1.35;';
            }
        }

        wrapper.querySelectorAll('[data-ai-link], a[href]').forEach((element: Element) => {
            const link = element as HTMLElement;
            const href = link.getAttribute('data-ai-link') || link.getAttribute('href');
            if (href) {
                const partnerHref = this.rewritePartnerOfferUrl(href);
                const requestedTarget = link.getAttribute('data-ai-target') || link.getAttribute('target');
                const belongsToNoOfferResponse = Boolean(link.closest(
                    '[data-ai-no-offer-response="true"], [data-ai-no-hotel-response="true"]',
                ));
                let isSameOrigin = false;
                try {
                    isSameOrigin = new URL(href, window.location.origin).origin === window.location.origin;
                } catch (_) {
                    isSameOrigin = false;
                }
                const target = requestedTarget === '_self' || (belongsToNoOfferResponse && isSameOrigin)
                    ? '_self'
                    : '_blank';
                link.setAttribute('data-ai-link', partnerHref);
                link.setAttribute('href', partnerHref);
                link.setAttribute('target', target);
                if (target === '_blank') {
                    link.setAttribute('rel', 'noopener noreferrer');
                } else {
                    link.removeAttribute('rel');
                }
            }
        });

        wrapper.querySelectorAll(
            '[data-ai-offer-response="true"] a, [data-ai-hotel-response="true"] a',
        ).forEach((element: Element) => {
            const link = element as HTMLElement;
            link.style.boxSizing = 'border-box';
            link.style.width = '100%';
            link.style.maxWidth = '100%';
            link.style.minWidth = '0';
            link.style.whiteSpace = 'normal';
            link.style.overflowWrap = 'anywhere';
            link.style.textAlign = 'center';
            link.style.lineHeight = '1.2';
        });

        const noOfferLink = wrapper.querySelector(
            '[data-ai-no-offer-response="true"] a, [data-ai-no-hotel-response="true"] a',
        ) as HTMLElement;
        if (noOfferLink) {
            noOfferLink.style.cssText = 'box-sizing:border-box;display:flex;align-items:center;justify-content:center;width:100%;max-width:100%;padding:12px 14px;border-radius:8px;background:#1467b3;color:#fff;text-decoration:none;font-weight:800;font-size:15px;line-height:1.1;cursor:pointer;';
        }

        const moreLink = wrapper.querySelector(
            '[data-ai-offer-response="true"] > a, [data-ai-hotel-response="true"] > a',
        ) as HTMLElement;
        if (moreLink) {
            moreLink.style.cssText = 'box-sizing:border-box;display:flex;align-items:center;justify-content:center;margin-top:2px;width:100%;padding:12px 14px;border-radius:8px;background:#ff7a1a;color:#fff;text-decoration:none;font-weight:800;font-size:16px;line-height:1.1;cursor:pointer;';
        }

        return wrapper.innerHTML;
    }

    /**
     * Offer tools historically return the platform URL
     * `suntour-reisen.de/{partnerid}/…`. Visitors of a white-label partner
     * must stay on that partner's own domain instead.
     */
    private rewritePartnerOfferUrl(href: string): string {
        const partnerDomain = String(this.partner?.partnerdomain || '')
            .trim()
            .replace(/^https?:\/\//i, '')
            .replace(/\/$/, '');
        const partnerId = String(this.partnerid || '').trim();
        if (!partnerDomain || !partnerId) return href;

        try {
            const url = new URL(href, window.location.origin);
            const platformDomain = url.hostname.toLowerCase().replace(/^www\./, '');
            const partnerPrefix = `/${partnerId.toLowerCase()}/`;
            if (
                platformDomain !== 'suntour-reisen.de'
                || !url.pathname.toLowerCase().startsWith(partnerPrefix)
            ) {
                return href;
            }

            const target = new URL(`https://${partnerDomain}`);
            url.protocol = target.protocol;
            url.host = target.host;
            // Strip the platform-only partner prefix, e.g. turn
            // /grenzenlos-fairreisen/offers into /offers.
            url.pathname = url.pathname.slice(partnerPrefix.length - 1);
            return url.toString();
        } catch (_) {
            return href;
        }
    }

    openAiMessageLink(event: MouseEvent): void {
        const target = event.target as HTMLElement;
        const carouselControl = target?.closest?.('[data-ai-card-carousel-scroll]') as HTMLElement;
        if (carouselControl) {
            event.preventDefault();
            event.stopPropagation();
            const shell = carouselControl.closest('[data-ai-card-carousel-shell]') as HTMLElement;
            const carousel = shell?.querySelector('[data-ai-card-carousel]') as HTMLElement;
            const viewport = shell?.querySelector('[data-ai-card-carousel-viewport]') as HTMLElement;
            const cards = carousel
                ? Array.from(carousel.querySelectorAll('[data-ai-offerpack-item], [data-ai-card="true"]')) as HTMLElement[]
                : [];
            if (shell && carousel && viewport && cards.length) {
                const cardWidth = cards[0].getBoundingClientRect().width;
                const gap = 12;
                const step = cardWidth + gap;
                // Use the actual overflow width. A card-count estimate is off
                // by a few pixels when the viewport or card gap changes.
                const maximumOffset = Math.max(0, carousel.scrollWidth - viewport.clientWidth);
                const maximumIndex = Math.ceil(maximumOffset / step);
                const currentIndex = Number(shell.getAttribute('data-ai-card-carousel-index') || 0);
                const direction = carouselControl.getAttribute('data-ai-card-carousel-scroll');
                const nextIndex = direction === 'previous'
                    ? Math.max(0, currentIndex - 1)
                    : Math.min(maximumIndex, currentIndex + 1);
                const nextOffset = Math.min(maximumOffset, nextIndex * step);
                carousel.style.transform = `translateX(-${nextOffset}px)`;
                shell.setAttribute('data-ai-card-carousel-index', String(nextIndex));
                const previous = shell.querySelector('[data-ai-card-carousel-scroll="previous"]') as HTMLButtonElement;
                const next = shell.querySelector('[data-ai-card-carousel-scroll="next"]') as HTMLButtonElement;
                const setControlVisible = (control: HTMLButtonElement, visible: boolean) => {
                    if (!control) return;
                    control.hidden = !visible;
                    // The buttons originate in server-rendered HTML and carry
                    // an inline display:flex style. Set display explicitly so
                    // that style can never override the hidden state.
                    control.style.display = visible ? 'flex' : 'none';
                };
                // The index is the authoritative navigation state. Apply it
                // immediately, then use the geometry check below as a
                // responsive-layout correction once the transition completes.
                setControlVisible(previous, nextIndex > 0);
                setControlVisible(next, nextIndex < maximumIndex);
                const updateCarouselControls = () => {
                    const viewportBounds = viewport.getBoundingClientRect();
                    const firstCardBounds = cards[0].getBoundingClientRect();
                    const lastCardBounds = cards[cards.length - 1].getBoundingClientRect();
                    setControlVisible(previous, nextIndex > 0 && firstCardBounds.left < viewportBounds.left - 1);
                    setControlVisible(next, nextIndex < maximumIndex && lastCardBounds.right > viewportBounds.right + 1);
                };

                // CSS animates the transform for 260ms. Measuring after it
                // finishes handles sub-pixel rounding and responsive widths.
                carousel.addEventListener('transitionend', updateCarouselControls, { once: true });
                window.setTimeout(updateCarouselControls, 300);
            }
            return;
        }
        const resultAction = target?.closest?.('[data-ai-result-action]') as HTMLElement;
        const resultActionText = resultAction?.getAttribute('data-ai-result-action');
        if (resultActionText) {
            event.preventDefault();
            event.stopPropagation();
            this.sendMessage(resultActionText);
            return;
        }
        const v2FollowUp = target?.closest?.('[data-ai-v2-follow-up-suggestion]') as HTMLElement;
        const v2FollowUpText = v2FollowUp?.getAttribute('data-ai-v2-follow-up-suggestion');
        if (v2FollowUpText) {
            event.preventDefault();
            event.stopPropagation();
            // A V2 follow-up is deliberately sent as ordinary customer text.
            this.sendMessage(v2FollowUpText);
            return;
        }
        const generatedQuickReply = target?.closest?.('[data-ai-generated-quick-reply]') as HTMLElement;
        const generatedReplyText = generatedQuickReply?.getAttribute('data-ai-generated-quick-reply');
        if (generatedReplyText) {
            event.preventDefault();
            event.stopPropagation();
            // "Zeige mir mehr Hotels" belongs to the result already shown in
            // this very message. Re-sending it to the assistant starts a new
            // (and unnecessary) AI/provider search, which can leave the chat
            // waiting although the complete, correctly filtered hotel list is
            // already available through the card's own link.
            if (/^\s*(?:zeige\s+mir\s+)?(?:weitere|mehr)\s+hotels?(?:\s+anzeigen)?\s*$/i.test(generatedReplyText)) {
                const messageRoot = target.closest('.cc10c');
                const moreHotelsLink = Array.from(
                    messageRoot?.querySelectorAll('[data-ai-hotel-response="true"] a[data-ai-link]') || [],
                ).find((element: Element) => /weitere\s+hotels\s+anzeigen|mehr\s+hotels\s+anzeigen/i.test(element.textContent || '')) as HTMLElement | undefined;
                const href = moreHotelsLink?.getAttribute('data-ai-link') || moreHotelsLink?.getAttribute('href');
                if (href) {
                    window.open(href, '_blank', 'noopener,noreferrer');
                    return;
                }
            }
            // This is a genuine new customer question, not a legacy menu
            // selection. Let it go through the AI queue and preserve the
            // current conversation context.
            this.sendMessage(generatedReplyText);
            return;
        }

        const callbackTime = target?.closest?.('[data-ai-callback-time]') as HTMLElement;
        if (callbackTime) {
            event.preventDefault();
            event.stopPropagation();
            const form = callbackTime.closest('[data-ai-callback-form]') as HTMLElement;
            const callbackTimeValue = callbackTime.getAttribute('data-ai-callback-time') || '';
            if (form && callbackTimeValue) {
                form.setAttribute('data-ai-selected-callback-time', callbackTimeValue);
                form.querySelectorAll('[data-ai-callback-time]').forEach((element: Element) => {
                    const button = element as HTMLElement;
                    const selected = button === callbackTime;
                    button.setAttribute('aria-pressed', selected ? 'true' : 'false');
                    button.style.background = selected ? '#e7f0ff' : '#fff';
                    button.style.borderColor = selected ? '#246dcc' : '#cbd7ec';
                });
            }
            return;
        }

        const callbackSubmit = target?.closest?.('[data-ai-callback-submit]') as HTMLElement;
        if (callbackSubmit) {
            event.preventDefault();
            event.stopPropagation();
            const form = callbackSubmit.closest('[data-ai-callback-form]') as HTMLElement;
            const country = form?.querySelector('[data-ai-callback-country]') as HTMLSelectElement;
            const input = form?.querySelector('[data-ai-callback-phone]') as HTMLInputElement;
            const error = form?.querySelector('[data-ai-callback-error]') as HTMLElement;
            const enteredNumber = String(input?.value || '').trim();
            const digits = enteredNumber.replace(/\D/g, '');
            if (digits.length < 6) {
                if (error) {
                    error.textContent = 'Bitte gib eine gültige Telefonnummer ein.';
                    error.style.display = 'block';
                }
                input?.focus();
                return;
            }

            const phone = enteredNumber.startsWith('+')
                ? enteredNumber
                : `${country?.value || '+49'} ${enteredNumber}`;
            const callbackTimeValue = form?.getAttribute('data-ai-selected-callback-time') || '';
            if (error) {
                error.style.display = 'none';
                error.textContent = '';
            }
            callbackSubmit.setAttribute('disabled', 'true');
            callbackSubmit.style.opacity = '.65';
            this.sendMessage(
                `Meine Telefonnummer für den Rückruf ist ${phone}.${callbackTimeValue ? ` Ich bin ${callbackTimeValue}.` : ''}`,
            );
            return;
        }

        const quickReply = target?.closest?.('[data-ai-quick-reply]') as HTMLElement;
        const replyText = quickReply?.getAttribute('data-ai-quick-reply');
        if (replyText) {
            event.preventDefault();
            event.stopPropagation();
            this.sendMessage(replyText, true);
            return;
        }

        // Hotel cards carry their resolved GIATA ID.  This must be handled
        // before generic links/quick replies so that the follow-up is always
        // about the exact displayed hotel, even where several hotels have a
        // similar name.
        const hotelInfo = target?.closest?.('[data-ai-hotel-info]') as HTMLElement;
        const hotelName = hotelInfo?.getAttribute('data-ai-hotel-name') || '';
        const giataId = hotelInfo?.getAttribute('data-ai-hotel-giata-id') || '';
        if (hotelInfo && hotelName) {
            event.preventDefault();
            event.stopPropagation();
            this.sendMessage(`Hotelinfos zu ${hotelName}${giataId ? ` [GIATA:${giataId}]` : ''}`);
            return;
        }

        const link = target?.closest?.('[data-ai-link], a[href]') as HTMLElement;
        const href = link?.getAttribute('data-ai-link') || link?.getAttribute('href');
        if (!href) {
            return;
        }

        const requestedTarget = link.getAttribute('data-ai-target') || link.getAttribute('target');
        const opensInCurrentTab = requestedTarget === '_self';

        // Same-tab links keep native navigation. New-tab links are opened
        // explicitly so embedded chat/webview contexts cannot ignore _blank.
        if (link instanceof HTMLAnchorElement && opensInCurrentTab) {
            link.href = new URL(href, window.location.origin).toString();
            link.target = '_self';
            link.removeAttribute('rel');
            return;
        }

        event.preventDefault();
        event.stopPropagation();
        const url = new URL(href, window.location.origin);
        if (opensInCurrentTab) {
            window.location.assign(url.toString());
        } else {
            window.open(url.toString(), '_blank', 'noopener,noreferrer');
        }
    }

    async scroolDown(behavior: ScrollBehavior = 'smooth') {
        const container = this.document.getElementById('msgContainer');
        if (container) {
            container.scrollTo({ top: container?.scrollHeight, behavior });
            // this.cdr.detectChanges();
        }
    }

    async initChat() {
        this.scroolDown();
        // Register the message and username listeners before asking
        // suntourserver for the greeting, so its first reply cannot be lost.
        this.initsocket();
        // Socket.IO may already be connected from the page load, but this
        // explicit event is the only frontend permission for suntourserver to
        // start an ElevenLabs greeting.
        this.chatService.startChatSession();
        this.initFromUser(this.currentMitarbeiter?.email);
    }

    async createRobotMessage(text) {
        const cryptos = this.encservice.encrypt(text);
        const message = {
            message: cryptos,
            type: 'robot',
            from: {
                last_connection: new Date(),
                status: 1,
                type: 'backoffice',
                username: 'backoffice',
                firstname: 'Reisebüro',
                lastname: 'Team'
            },
            to: {
                last_connection: new Date(),
                status: 1,
                type: 'web',
                username: window.localStorage.getItem(this.partnerid + '_sessionid')
            },
            status: 1,
            date: new Date()
        } as Message;
        this.chatService.sendMessage<Message>(message, (res) => {
            // Add message in to the list
            message.message = text;
            this.appendMessage(message);
            setTimeout(() => {
                this.scroolDown();
            }, 200);
        });
    }

    async closeChat() {
        this.chatpanel = false;
        this.resetRobot();
        this.triggerclosechat.emit(true);
    }

    async gotoCalendar() {
        this.sendMessage('Ich vereinbare einen persönlichen Termin.', true);
        this.router.navigate(['terminkalender']);
        if (this.desktopTemplate === 'xs' || this.desktopTemplate === 'sm') {
            this.closeChat();
        }
    }

    async gotSktv() {
        if (this.sktvnumber?.length > 0) {
            this.sktvnumbererror = false;
            const navigationExtras: NavigationExtras = {
                queryParams: { params: this.encservice.encrypt({ extra: { orderId: this.sktvnumber } }) }
            };
            const url = this.router.createUrlTree(['sktv'], navigationExtras).toString();
            const link = document.createElement('a');
            link.href = url;
            link.target = '_blank';
            link.setAttribute('visibility', 'hidden');
            link.click();
        } else {
            this.sktvnumbererror = true;
            this.cdr.detectChanges();
            setTimeout(() => {
                this.scroolDown();
            }, 200);
        }
    }

    async createHibridMessage(text, cb) {
        const cryptos = this.encservice.encrypt(text);
        const message = {
            message: cryptos,
            type: 'robot',
            from: {
                last_connection: new Date(),
                status: 1,
                type: 'backoffice',
                username: this.currentFrom?.username,
                firstname: this.currentFrom?.firstname,
                lastname: this.currentFrom?.lastname
            },
            to: {
                last_connection: new Date(),
                status: 1,
                type: 'web',
                username: window.localStorage.getItem(this.partnerid + '_sessionid')
            },
            status: 1,
            date: new Date()
        } as Message;
        this.chatService.sendMessage<Message>(message, (res) => {
            // Add message in to the list
            message.message = text;
            message.avatar = this.currentFrom?.avatar;
            this.appendMessage(message);
            cb();
        });
    }

    sendemail(val, token) {
        let html = '<b>Anfrage von chat</b>';
        html += '<br><br>';
        html += 'Vorname: ' + val.firstname;
        html += '<br><br>';
        html += 'Name: ' + val.lastname;
        html += '<br><br>';
        html += 'Telefonnummer: ' + val.tel;
        html += '<br><br>';
        html += 'Email: ' + val.email;
        html += '<br><br>';
        html += 'Message: ' + val.message;
        html += '<br><br>';
        let emailBody = '';
        emailBody += '<html>';
        emailBody += '<head>';
        emailBody += '<meta http-equiv="Content-Type" content="text/html; charset=UTF-8">';
        emailBody += '<meta name="viewport" content="width=device-width, initial-scale=1.0">';
        emailBody += '<style type="text/css">';
        emailBody += `
        HTMLBody, body {
            background-color: #f3f3f3;
        }
        table {
            mso-table-lspace: 0pt;
            mso-table-rspace: 0pt;
            border-collapse: collapse;
            border-spacing: 0px;
            outline: 0;
            margin: 5px;
        }
        `;
        emailBody += '</style>';
        emailBody += '</head>';
        emailBody += '<HTMLBody bgcolor="#f3f3f3">';
        emailBody += '<table><tr><td>';
        emailBody += html;
        emailBody += '</td></tr></table>';
        emailBody += '</HTMLBody></html>';
        this.chatService.sendemail({
            partnerid: this.partnerid,
            partnerdomain: this.partner.partnerdomain,
            email: this.partner.email,
            subject: 'Anfrage von chat',
            datahtml: emailBody,
            token: token
        }, (res) => {
            // console.log(res);
        });
    }

    // new version
    async startTimer(cb) {
        this.showwaiting30secLoading = true;
        this.cdr.detectChanges();
        this.timer30 = 15;
        const source = timer(0, 1000);
        this.showwaiting30secLoadingSub?.unsubscribe();
        this.showwaiting30secLoadingSub = source.subscribe(_ => {
            if (this.timer30 > 0) {
                this.timer30 = this.timer30 - 1;
                this.cdr.detectChanges();
            } else {
                cb();
            }
        });

        setTimeout(() => {
            this.scroolDown();
        }, 200);
    }

    async startTalk() {
        if (!this.messages()[this.messages()?.length - 1]?.message.endsWith(this.msg11) && !this.IchatUser.stopRobot) {
            const text = this.msg1 + this.currentFrom?.firstname + this.msg11;
            this.createHibridMessage(text, () => {
                this.showmb1 = true;
                this.cdr.detectChanges();
                setTimeout(() => {
                    this.scroolDown();
                }, 300);
            });
        } else {
            if (!this.IchatUser.stopRobot) {
                this.showmb1 = true;
                this.cdr.detectChanges();
            }
            setTimeout(() => {
                this.scroolDown();
            }, 300);
        }
    }

    waiting30sec(cb): void {
        this.stopTimer();
        setTimeout(() => {
            this.startTimer(cb);
        }, 200);
    }

    closeAllbtns(): void {
        this.showphonformular = false;
        this.showmailformular = false;
        this.reloadconfirmation.set(false);
        this.showandereFrageformular = false;
        this.showandereFrageformular1 = false;
        this.showandereFrageformular2 = false;
        this.showmb1 = false;
        this.showmb2 = false;
        this.showmb3 = false;
        this.showmb4 = false;
        this.showmb5 = false;
        this.showmb6 = false;
        this.showmb7 = false;
        this.cdr.detectChanges();
    }

    stopTimer(): void {
        this.showwaiting30secLoading = false;
        this.cdr.detectChanges();
        this.showwaiting30secLoadingSub?.unsubscribe();
    }

    isAiChatActive(): boolean {
        return this.partner?.aiAssistantEnabled === true || this.partner?.ai?.elevenLabsEnabled === true;
    }

    private isElevenLabsTextChatEnabled(): boolean {
        return this.partner?.ai?.elevenLabsEnabled === true
            && Boolean(this.partner?.ai?.elevenLabsTextAgentId);
    }

    private shouldUseElevenLabsTextAgent(isOption?: boolean, type?: string): boolean {
        return this.isElevenLabsTextChatEnabled()
            && !this.IchatUser?.stopRobot
            && !isOption
            && (!type || type === 'text');
    }

    shouldUseAiAnswer(isOption?: boolean, type?: string): boolean {
        return this.isAiChatActive() && !this.IchatUser?.stopRobot && !isOption && (!type || type === 'text');
    }

    isAiOfferMessage(msg: Message): boolean {
        return typeof msg?.message === 'string' && (
            // Markdown links returned by ElevenLabs are normalized to this
            // safe marker. They must bypass the legacy linkify pipe, which
            // otherwise deliberately removes existing <a> elements.
            msg.message.includes('data-ai-link=') ||
            msg.message.includes('data-ai-offer-response="true"') ||
            msg.message.includes('data-ai-hotel-response="true"') ||
            msg.message.includes('data-ai-combined-offer-response="true"') ||
            msg.message.includes('data-ai-no-offer-response="true"') ||
            msg.message.includes('data-ai-no-hotel-response="true"') ||
            msg.message.includes('data-ai-ferienhaus-advice="true"') ||
            msg.message.includes('data-ai-info-response="true"') ||
            msg.message.includes('data-ai-travel-confirmation="true"') ||
            msg.message.includes('data-ai-advisor-request="true"') ||
            msg.message.includes('data-ai-v2-response="true"') ||
            msg.message.includes('data-ai-generated-quick-replies="true"') ||
            msg.message.includes('data-ai-v2-follow-up-suggestions="true"') ||
            msg.message.includes('data-ai-offerpack-email="true"') ||
            msg.message.includes('data-ai-weather-response="true"') ||
            msg.message.includes('data-ai-travel-info-response="true"')
        );
    }

    startAiWaiting(message = 'Ich prüfe deine Anfrage...'): void {
        this.aiProgressMessage.set(message);
        this.aiProgressSteps.set([]);
        this.aiProgressJobId.set('');
        this.aiWaiting.set(true);
        clearTimeout(this.aiWaitingTimeout);
        this.aiWaitingTimeout = setTimeout(() => {
            this.stopAiWaiting();
        }, 45000);
        this.cdr.detectChanges();
        setTimeout(() => {
            this.scroolDown();
        }, 200);
    }

    stopAiWaiting(): void {
        clearTimeout(this.aiWaitingTimeout);
        if (this.aiWaiting()) {
            this.aiWaiting.set(false);
            this.aiProgressSteps.set([]);
            this.aiProgressJobId.set('');
            this.cdr.detectChanges();
        }
    }

    scheduleAiResponseSync(): void {
        this.stopAiResponseSync();
        this.aiResponseSyncAttempt = 0;
        this.queueAiResponseSync();
    }

    queueAiResponseSync(): void {
        const delays = [4000, 9000, 16000];
        const delay = delays[this.aiResponseSyncAttempt];
        if (!delay) {
            return;
        }

        this.aiResponseSyncTimeout = setTimeout(() => {
            const username = window.localStorage.getItem(this.partnerid + '_sessionid');
            if (!username || !this.aiWaiting()) {
                return;
            }

            this.getmymesages(username, { silent: true });
            this.aiResponseSyncAttempt += 1;
            this.queueAiResponseSync();
        }, delay);
    }

    stopAiResponseSync(): void {
        clearTimeout(this.aiResponseSyncTimeout);
        this.aiResponseSyncAttempt = 0;
    }

    async startWeitereWachten(msg) {
        this.closeAllbtns();
        this.showmb3whaite = false;
        this.cdr.detectChanges();
        setTimeout(() => {
            this.sendMessage(msg, true);
            this.waiting30sec(() => {
                this.stopTimer(); // stop timer
                this.showmb3whaite = true;
                this.cdr.detectChanges();
                setTimeout(() => {
                    this.scroolDown();
                }, 200);
            });
            setTimeout(() => {
                this.scroolDown();
                this.showmb3 = true;
                this.cdr.detectChanges();
                setTimeout(() => {
                    this.scroolDown();
                }, 200);
            }, 500);
            // setTimeout(() => {
            //     const text = this.msg4 + this.currentFrom.firstname + this.msg41;
            //     this.createRobotMessage(text);
            //     setTimeout(() => {
            //         this.scroolDown();
            //         this.showmb3 = true;
            //         setTimeout(() => {
            //             this.scroolDown();
            //         }, 200);
            //     }, 500);
            // }, 500);
        }, 200);
    }

    async startWeitereWachtenV4(msg) {
        this.closeAllbtns();
        this.showmb4whaite = false;
        this.cdr.detectChanges();
        setTimeout(() => {
            this.sendMessage(msg, true);
            this.waiting30sec(() => {
                this.stopTimer(); // stop timer
                this.showmb4whaite = true;
                this.cdr.detectChanges();
            });
            setTimeout(() => {
                this.scroolDown();
                this.showmb5 = true;
                this.cdr.detectChanges();
                setTimeout(() => {
                    this.scroolDown();
                }, 200);
            }, 500);
            // setTimeout(() => {
            //     const text = this.msg4 + this.currentFrom.firstname + this.msg42;
            //     this.createRobotMessage(text);
            //     setTimeout(() => {
            //         this.scroolDown();
            //         this.showmb5 = true;
            //         setTimeout(() => {
            //             this.scroolDown();
            //         }, 200);
            //     }, 500);
            // }, 500);
        }, 200);
    }

    async startWeitereWachtenV5(msg) {
        this.closeAllbtns();
        this.showmb5whaite = false;
        this.cdr.detectChanges();
        setTimeout(() => {
            this.sendMessage(msg, true);
            this.waiting30sec(() => {
                this.stopTimer(); // stop timer
                this.showmb5whaite = true;
                this.cdr.detectChanges();
            });
            setTimeout(() => {
                this.scroolDown();
                this.showmb7 = true;
                this.cdr.detectChanges();
                setTimeout(() => {
                    this.scroolDown();
                }, 200);
            }, 500);
            // setTimeout(() => {
            //     const text = this.msg4 + this.currentFrom.firstname + this.msg42;
            //     this.createRobotMessage(text);
            //     setTimeout(() => {
            //         this.scroolDown();
            //         this.showmb7 = true;
            //         setTimeout(() => {
            //             this.scroolDown();
            //         }, 200);
            //     }, 500);
            // }, 500);
        }, 200);
    }

    async gotobackbooking() {
        this.showbookingformular = false;
        this.cdr.detectChanges();
        this.returnmb1();
    }

    async sendbookingnumber() {
        if (this.bookingnumber?.length > 0) {
            this.bookingnumberrerror = false;
            this.showbookingformular = false;
            this.cdr.detectChanges();
            this.sendMessage(this.bookingnumber, true);
            setTimeout(() => {
                this.gobackinmenu = this.returnmb1.bind(this);
                this.waiting30sec(() => {
                    this.stopTimer(); // stop timer
                    this.createHibridMessage(this.msg3, () => {
                        this.showmb2 = true;
                        this.cdr.detectChanges();
                        setTimeout(() => {
                            this.scroolDown();
                        }, 300);
                    });
                });
                setTimeout(() => {
                    this.scroolDown();
                }, 200);
            }, 200);
        } else {
            this.bookingnumberrerror = true;
            this.cdr.detectChanges();
            setTimeout(() => {
                this.scroolDown();
            }, 200);
        }
    }

    async startReisebuchung(msg) {
        this.closeAllbtns();
        setTimeout(() => {
            this.sendMessage(msg, true);
            setTimeout(() => {
                const text = this.msg1 + this.currentFrom.firstname + this.msg12;
                this.createHibridMessage(text, () => {
                    this.showbookingformular = true;
                    this.cdr.detectChanges();
                    setTimeout(() => {
                        this.scroolDown();
                    }, 200);
                });
            }, 500);
            // setTimeout(() => {
            //     const text = this.msg1 + this.currentFrom.firstname + this.msg12;
            //     this.createHibridMessage(text, () => {
            //         this.gobackinmenu = this.returnmb1.bind(this);
            //         this.waiting30sec(() => {
            //             this.stopTimer(); // stop timer
            //             this.createHibridMessage(this.msg3, () => {
            //                 this.showmb2 = true;
            //                 setTimeout(() => {
            //                     this.scroolDown();
            //                 }, 300);
            //             });
            //         });
            //         setTimeout(() => {
            //             this.scroolDown();
            //         }, 200);
            //     });
            // }, 500);
        }, 200);
    }

    async startsktv(msg) {
        this.closeAllbtns();
        setTimeout(() => {
            this.sendMessage(msg, true);
            setTimeout(() => {
                const text = this.msg6 + this.currentFrom.firstname + this.msg61;
                this.createHibridMessage(text, () => {
                    this.showphonsktvformular = true;
                    this.cdr.detectChanges();
                    setTimeout(() => {
                        this.scroolDown();
                    }, 200);
                });
            }, 500);
            // setTimeout(() => {
            //     const text = this.msg6 + this.currentFrom.firstname + this.msg61;
            //     this.createHibridMessage(text, () => {
            //         this.gobackinmenu = this.returnmb1.bind(this);
            //         this.waiting30sec(() => {
            //             this.stopTimer(); // stop timer
            //             this.createHibridMessage(this.msg3, () => {
            //                 this.showmb6 = true;
            //                 setTimeout(() => {
            //                     this.scroolDown();
            //                 }, 300);
            //             });
            //         });
            //         setTimeout(() => {
            //             this.scroolDown();
            //         }, 200);
            //     });
            // }, 500);
        }, 200);
    }

    async gotobacksktv() {
        this.showphonsktvformular = false;
        this.cdr.detectChanges();
        this.returnmb1();
    }

    async sendsktvnumber() {
        if (this.sktvnumber?.length > 0) {
            this.sktvnumbererror = false;
            this.showphonsktvformular = false;
            this.cdr.detectChanges();
            this.sendMessage(this.sktvnumber, true);
            setTimeout(() => {
                this.gobackinmenu = this.returnmb1.bind(this);
                this.waiting30sec(() => {
                    this.stopTimer(); // stop timer
                    this.createHibridMessage(this.msg3, () => {
                        this.showmb6 = true;
                        setTimeout(() => {
                            this.scroolDown();
                        }, 300);
                    });
                });
                setTimeout(() => {
                    this.scroolDown();
                }, 200);
            }, 200);
        } else {
            this.sktvnumbererror = true;
            this.cdr.detectChanges();
            setTimeout(() => {
                this.scroolDown();
            }, 200);
        }
    }

    async startNeueReise(msg) {
        this.closeAllbtns();
        setTimeout(() => {
            this.sendMessage(msg, true);
            setTimeout(() => {
                const text = this.msg8 + this.currentFrom.firstname + this.msg81;
                this.createHibridMessage(text, () => {
                    this.gobackinmenu = this.returnmb1.bind(this);
                    this.waiting30sec(() => {
                        this.stopTimer(); // stop timer
                        this.createHibridMessage(this.msg3, () => {
                            this.showmb4 = true;
                            this.cdr.detectChanges();
                            setTimeout(() => {
                                this.scroolDown();
                            }, 300);
                        });
                    });
                    setTimeout(() => {
                        this.scroolDown();
                    }, 200);
                });
            }, 500);
        }, 200);
    }

    returnmb1(): void {
        this.stopTimer(); // stop timer
        this.closeAllbtns();
        this.showmb1 = true; // show origin buttons
        this.cdr.detectChanges();
        setTimeout(() => {
            this.scroolDown();
        }, 200);
    }

    returnmb2(): void {
        this.stopTimer(); // stop timer
        this.closeAllbtns();
        this.showmb2 = true; // show origin buttons
        this.cdr.detectChanges();
        setTimeout(() => {
            this.scroolDown();
        }, 200);
    }

    returnmb3(): void {
        this.stopTimer(); // stop timer
        this.closeAllbtns();
        this.showmb1 = true; // show origin buttons
        this.cdr.detectChanges();
        setTimeout(() => {
            this.scroolDown();
        }, 200);
    }

    returnmb4(): void {
        this.stopTimer(); // stop timer
        this.closeAllbtns();
        this.showmb6 = true; // show origin buttons
        this.cdr.detectChanges();
        setTimeout(() => {
            this.scroolDown();
        }, 200);
    }

    async gotoReisekompass(msg, params) {
        this.sendMessage(msg, true);
        const url = this.router.createUrlTree(['contents']).toString();
        this.router.navigateByUrl(url + params);
        if (this.desktopTemplate === 'xs' || this.desktopTemplate === 'sm') {
            this.closeChat();
        }
    }

    async gotoAnfrage(msg) {
        this.sendMessage(msg, true);
        const url = this.router.createUrlTree(['anfrage']).toString();
        this.router.navigateByUrl(url);
        if (this.desktopTemplate === 'xs' || this.desktopTemplate === 'sm') {
            this.closeChat();
        }
    }

    focusInput(msg) {
        this.focus = true;
        this.cdr.detectChanges();
        setTimeout(() => {
            this.closeAllbtns();
            this.sendMessage(msg, true);
        }, 500);
    }

    showPhonNumber() {
        this.closeAllbtns();
        this.sendMessage('Ich bitte um einen Rückruf.', true);
        this.showphonformular = true;
        this.cdr.detectChanges();
        setTimeout(() => {
            this.scroolDown();
        }, 200);
    }

    openandereFrageformular() {
        this.closeAllbtns();
        this.sendMessage('Ich habe eine Frage zu einem anderen Thema.', true);
        this.showandereFrageformular = true;
        this.cdr.detectChanges();
        setTimeout(() => {
            this.scroolDown();
        }, 200);
    }

    openandereFrageformular1() {
        this.closeAllbtns();
        this.sendMessage('Ich habe eine andere Frage.', true);
        this.showandereFrageformular1 = true;
        this.cdr.detectChanges();
        setTimeout(() => {
            this.scroolDown();
        }, 200);
    }

    openandereFrageformular2() {
        this.closeAllbtns();
        this.sendMessage('Ich habe eine Frage zu einem anderen Thema.', true);
        this.showandereFrageformular2 = true;
        this.cdr.detectChanges();
        setTimeout(() => {
            this.scroolDown();
        }, 200);
    }

    showMail() {
        this.closeAllbtns();
        this.sendMessage('Ich schicke eine Email.', true);
        this.showmailformular = true;
        this.cdr.detectChanges();
        setTimeout(() => {
            this.scroolDown();
        }, 200);
    }

    async sendFormular(val, msfr) {
        this.closeAllbtns();
        this.recaptchaV3Service.execute('chatphonenumberformular').pipe(
            takeUntilDestroyed(this.destroyRef),
        ).subscribe((token) => {
            this.createRobotMessage(msfr);
            setTimeout(() => {
                this.scroolDown();
            }, 150);
            this.sendemail(val, token);
        });
    }

    async closeFormular(val) {
        if (val) {
            this.closeAllbtns();
            this.showmb2 = true;
            this.cdr.detectChanges();
        }
    }

    async closeAndereFrageFormular(val) {
        if (val) {
            this.closeAllbtns();
            this.showmb3 = true;
            this.cdr.detectChanges();
        }
    }

    async closeAndereFrageFormular1(val) {
        if (val) {
            this.closeAllbtns();
            this.showmb5 = true;
            this.cdr.detectChanges();
        }
    }

    async closeAndereFrageFormular2(val) {
        if (val) {
            this.closeAllbtns();
            this.showmb7 = true;
            this.cdr.detectChanges();
        }
    }

    async openFilesBrowser(ev) {
        ev.stopPropagation();
        if (this.filesBrowser && this.filesBrowser.nativeElement) {
            this.filesBrowser.nativeElement.click();
            ev.stopPropagation();
        }
    }

    async multipleFilesChangeEvent(fileInput: any) {
        if (fileInput.target && fileInput.target.files && fileInput.target.files.length > 0) {
            const files = fileInput.target.files;
            const fsize = files[0].size;
            const filemb = Math.round((fsize / 1024) / 1024);
            if (filemb <= 10) {
                this.selectedblb = await this.upload(files[0]);
                this.showbigImage.set(true);
                this.sendImgBtn.set(true);
            }
        }
    }

    async upload(file: any) {
        return new Promise(done => {
            if (file) {
                // eslint-disable-next-line no-undef
                const reader = new FileReader();
                reader.onload = () => {
                    done(reader.result);
                };
                reader.readAsDataURL(file);
            } else {
                done(null);
            }
        });
    }

    async closeImgModal() {
        this.showbigImage.set(false);
        this.sendImgBtn.set(false);
        this.selectedblb = null;
        this.cdr.detectChanges();
    }

    async sendImmage() {
        const tmp = this.downscaleImage(this.selectedblb, 300);
        this.sendMessage(tmp, false, 'image');
        this.trackForm.controls['text'].setValue('');
        this.showbigImage.set(false);
        this.selectedblb = null;
        this.cdr.detectChanges();
    }

    downscaleImage(dataUrl, newWidth, imageType?, imageArguments?) {
        // Provide default values
        imageType = imageType || 'image/jpeg';
        imageArguments = imageArguments || 0.7;

        // Create a temporary image so that we can compute the height of the downscaled image.
        // eslint-disable-next-line no-undef
        const image = new Image();
        image.src = dataUrl;
        const oldWidth = image.width;
        const oldHeight = image.height;
        const newHeight = Math.floor(oldHeight / oldWidth * newWidth)

        // Create a temporary canvas to draw the downscaled image on.
        const canvas = document.createElement('canvas');
        canvas.width = newWidth;
        canvas.height = newHeight;

        // Draw the downscaled image on the canvas and return the new data URL.
        const ctx = canvas.getContext('2d');
        ctx.drawImage(image, 0, 0, newWidth, newHeight);
        const newDataUrl = canvas.toDataURL(imageType, imageArguments);
        return newDataUrl;
    }
}
